import PropTypes from "prop-types"
import { useState } from 'react'
import intl from "react-intl-universal";
import Select from 'react-select';
import { customStyle, OntimeSelectLabel, OntimeSelectWrapper } from "./styled";
import { normalizeOptions, normalizeValue } from "./utils/normalize";

const SelectBox = ({
  dontShowLabel = false,
  label = "",
  placeholder,
  options,
  onChange,
  clearable = false,
  searchable = true,
  multi = false,
  disabled = false,
  valueKey,
  labelKey,
  isLoading = undefined,
  width = undefined,
  name,
  value,
  isPrimaryMaterial = undefined,
  limitOptions = 100,
  menuListStyle = {},
  styles: customStyles = {},
  menuPortalTarget = undefined,
  ...rest
}) => {
  const [searchFilterSelect, setSearchFilterSelect] = useState("");
  const filterOptions = (list, label) => {
    if (!Array.isArray(list)) {
      return [];
    }
    let _list = list;
    if (searchFilterSelect) {
      _list = list.filter((x) => x[label].toLowerCase().includes(searchFilterSelect));
    }
    if (_list && _list.length > limitOptions) {
      return [
        ..._list.slice(0, limitOptions),
        { [label]: intl.get("commons.typeToFind"), isDisabled: true },
      ];
    }
    return [..._list.slice(0, limitOptions)];
  };

  const mergedStyles = {
    ...customStyle(menuListStyle),
    ...customStyles,
  };

  return (
    <OntimeSelectWrapper
      data-testid={rest["data-testid"]}
      isPrimaryMaterial={isPrimaryMaterial}
      dontShowLabel={dontShowLabel}
      width={width}
    >
      <OntimeSelectLabel dontShowLabel={dontShowLabel} htmlFor={label}>
        {label}
      </OntimeSelectLabel>
      <Select
        inputId={label}
        name={name}
        placeholder={placeholder}
        styles={mergedStyles}
        isClearable={clearable}
        isSearchable={searchable}
        isMulti={multi}
        isDisabled={disabled}
        isLoading={isLoading}
        onChange={onChange}
        value={multi && !value ? [] : normalizeValue(value, labelKey, valueKey, options, multi)}
        options={normalizeOptions(filterOptions(options, labelKey), labelKey, valueKey)}
        onInputChange={(value) => setSearchFilterSelect(value.toLowerCase())}
        menuPortalTarget={menuPortalTarget}
        {...rest}
      />
    </OntimeSelectWrapper>
  );
}

SelectBox.propTypes = {
  clearable: PropTypes.any.isRequired,
  disabled: PropTypes.any.isRequired,
  dontShowLabel: PropTypes.bool.isRequired,
  isLoading: PropTypes.any.isRequired,
  isPrimaryMaterial: PropTypes.any.isRequired,
  label: PropTypes.string.isRequired,
  labelKey: PropTypes.any.isRequired,
  limitOptions: PropTypes.number.isRequired,
  menuListStyle: PropTypes.object.isRequired,
  multi: PropTypes.bool.isRequired,
  name: PropTypes.any.isRequired,
  onChange: PropTypes.any.isRequired,
  options: PropTypes.any.isRequired,
  placeholder: PropTypes.any.isRequired,
  searchable: PropTypes.bool.isRequired,
  value: PropTypes.shape({
    toLowerCase: PropTypes.func,
  }).isRequired,
  valueKey: PropTypes.any.isRequired,
  width: PropTypes.any.isRequired,
  styles: PropTypes.object.isRequired,
  menuPortalTarget: PropTypes.any,
};

export { SelectBox }
